module.exports = __webpack_public_path__ + "media/images/front/team/javier_lizandra-5a69b4a73eedd32dd787b04f67d6dff2.jpg";